// Update 
export const UPDATE_CHANNEL_DATA_REQUEST = 'UPDATE_CHANNEL_DATA_REQUEST';
export const UPDATE_CHANNEL_DATA_SUCCESS = 'UPDATE_CHANNEL_DATA_SUCCESS';
export const UPDATE_CHANNEL_DATA_FAILURE = 'UPDATE_CHANNEL_DATA_FAILURE';
export const UPDATE_CHANNEL_DATA_RESET = 'UPDATE_CHANNEL_DATA_RESET';
// Save data actions
export const updateChannelDataRequest = (payload) => ({
    type: UPDATE_CHANNEL_DATA_REQUEST,
    payload
});
export const updateChannelDataSuccess = (payload) => ({
    type: UPDATE_CHANNEL_DATA_SUCCESS,
    payload,
});
export const updateChannelDataFailure = (error) => ({
    type: UPDATE_CHANNEL_DATA_FAILURE,
    payload: error,
});
export const updateChannelDataReset = () => ({
    type: UPDATE_CHANNEL_DATA_RESET,
});
